export const createFontFacesString = (
    fontFamily: string,
    files: Array<{ name: string; weight: number; style: string }>
) =>
    files
        .map(
            (file) => `
    @font-face {
        font-family: '${fontFamily}';
        font-style: ${file.style};
        font-weight: ${file.weight};
        font-display: swap;
        src: url('/fonts/${file.name}.woff2') format('woff2');
    }
    `
        )
        .join('');

export const hurmeGeometricSansNo4Files = [
    { name: 'HurmeGeometricSans_No4_1_Hairline', weight: 100, style: 'normal' },
    { name: 'HurmeGeometricSans_No4_Oblique_1_Hairline', weight: 100, style: 'italic' },
    { name: 'HurmeGeometricSans_No4_2_Thin', weight: 200, style: 'normal' },
    { name: 'HurmeGeometricSans_No4_Oblique_2_Thin', weight: 200, style: 'italic' },
    { name: 'HurmeGeometricSans_No4_3_Light', weight: 300, style: 'normal' },
    { name: 'HurmeGeometricSans_No4_Oblique_3_Light', weight: 300, style: 'italic' },
    { name: 'HurmeGeometricSans_No4_4_Regular', weight: 400, style: 'normal' },
    { name: 'HurmeGeometricSans_No4_Oblique_4_Regular', weight: 400, style: 'italic' },
    { name: 'HurmeGeometricSans_No4_5_SemiBold', weight: 600, style: 'normal' },
    { name: 'HurmeGeometricSans_No4_Oblique_5_SemiBold', weight: 600, style: 'italic' },
    { name: 'HurmeGeometricSans_No4_6_Bold', weight: 700, style: 'normal' },
    // Brak pliku HurmeGeometricSans_No4_Oblique_6_Bold w dostarczonych, pomijam
    { name: 'HurmeGeometricSans_No4_7_Black', weight: 900, style: 'normal' },
    { name: 'HurmeGeometricSans_No4_Oblique_7_Black', weight: 900, style: 'italic' },
];
